<template>
  <div class="container multi-card-container">
    <div class="col-lg-12 card-col">
      <div class="card-ct card-rounded-shadowed">
        <h2 class="mb-4">{{ 'Bloga rediģēšana' }}</h2>
        <b-button variant="primary" :to="{ name: 'Admin', params: { tab: 'blog' } }">{{ 'Atpakaļ' }}</b-button>
        <div class="float-right">
          <b-button variant="danger" @click="deleteBlog" v-if="edit">
            <b-spinner v-if="spinners.isDeleting" type="grow" variant="primary"/>
            <span v-else>{{ 'Dzēst' }}</span>
          </b-button>
          <b-button variant="success" class="ml-2" @click="saveBlog">
            <b-spinner v-if="spinners.isSaving" type="grow" variant="primary"/>
            <span v-else>{{ 'Saglabāt' }}</span>
          </b-button>
        </div>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div class="row mt-4" v-else>
          <div class="col-12">
            <form>
              <TextsInput :fields="textsFields" v-model="texts"/>
              <b-form-group :label="'Kārtošanas secība'">
                <b-form-input
                    v-model="order"
                    type="number"
                    required
                    :placeholder="'Ievadi kārtošanas secību'"></b-form-input>
              </b-form-group>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextsInput from '@/components/Texts/TextsInputComponent';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';
import statuses from '@/store/statuses';
import Services from '@/services/index';

const AdminTypes = VuexTypes.admin;
const AdminService = Services.admin;

export default {
  components: { TextsInput },
  props: [],
  mounted() {
    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    }
  },
  computed: {
    ...mapGetters('Admin', [
      'blogsView',
      'blogsCreate',
      'blogsUpdate',
      'blogsDelete'
    ]),
  },
  watch: {
    blogsView: {
      handler() {
        if (this.blogsView.status === statuses.LOADED) {
          this.spinners.contentIsLoading = false;
          this.texts = this.blogsView.data.data.texts;
          this.order = this.blogsView.data.data.order;
        }
      },
      deep: true
    },
    blogsCreate: {
      handler() {
        if (this.blogsCreate.status === statuses.LOADED) {
          this.spinners.isSaving = false;
          this.$router.push({ name: 'Admin', params: { tab: 'blog' } });
          this.alertSuccess();
        }
      },
      deep: true
    },
    blogsUpdate: {
      handler() {
        if (this.blogsUpdate.status === statuses.LOADED) {
          this.spinners.isSaving = false;
          this.$router.push({ name: 'Admin', params: { tab: 'blog' } });
          this.alertSuccess();
        }
      },
      deep: true
    },
    blogsDelete: {
      handler() {
        if (this.blogsDelete.status === statuses.LOADED) {
          this.spinners.isDeleting = false;
        }
      },
      deep: true
    }
  },
  data() {
    return {
      edit: false,
      spinners: {
        isSaving: false,
        isDeleting: false,
        contentIsLoading: false
      },
      order: 0,
      texts: {
        lv: {
          title: null,
          content: null
        },
        en: {
          title: null,
          content: null
        }
      },
      textsFields: [
        {
          id: 'title',
          label: 'Virsraksts',
          placeholder: 'Ievadi virsrakstu',
          type: 'text',
          isRequired: true
        },
        {
          id: 'html_content',
          label: 'Saturs',
          type: 'editor',
          isRequired: true,
          options: {
            height: 400,
            images_upload_handler: this.handleMediaUpload,
            placeholder: 'Ievadi saturu',
            plugins: [
              'lists link image media paste help wordcount code'
            ]
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions('Admin', [
      AdminTypes.ADMIN_BLOGS_VIEW,
      AdminTypes.ADMIN_BLOGS_CREATE,
      AdminTypes.ADMIN_BLOGS_UPDATE,
      AdminTypes.ADMIN_BLOGS_DELETE
    ]),
    getData() {
      this.spinners.contentIsLoading = true;
      this.ADMIN_BLOGS_VIEW(this.$route.params.id);
    },
    saveBlog() {
      this.spinners.isSaving = true;
      const data = {
        order: this.order,
        texts: this.texts
      };

      if (this.edit) {
        this.ADMIN_BLOGS_UPDATE({
          blog: this.$route.params.id,
          data
        })
      } else {
        this.ADMIN_BLOGS_CREATE(data);
      }
    },
    deleteBlog() {
      this.spinners.isDeleting = true;
      this.ADMIN_BLOGS_DELETE(this.$route.params.id).then((res) => {
        if (res.data.status === true) {
          this.$router.push({ name: 'Admin', params: { tab: 'blog' } });
        }
      });
    },
    handleMediaUpload(blobInfo, success, failure, progress) {
      const formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      AdminService.blogsMediaUpload(formData)
        .then((response) => {
          success(response.data.data);
        })
        .catch((reason) => {
          failure('Kļūda faila augšupielādē');
        });
    }
  }
}
</script>

<style scoped>
.tabs {
  width: 100%;
}
</style>
